module.exports = __webpack_public_path__ + "static/media/wardrobe.4d445614.png";